__turbopack_context__.v({
  "animatedLink": "nSxWga_animatedLink",
  "footer": "nSxWga_footer",
  "footerBottomMenu": "nSxWga_footerBottomMenu",
  "footerTile": "nSxWga_footerTile",
  "sectionHeading": "nSxWga_sectionHeading",
});
